const activeTimeouts = [];

export function clearTimeouts() {
    activeTimeouts.forEach((t) => clearTimeout(t));
}

export function timeout(fn, delay) {
    activeTimeouts.push(setTimeout(fn, delay));
}

export function saveTimeout(timeoutHandle) {
    activeTimeouts.push(timeoutHandle);
}
